import { useState } from "react";
import { Box, Button, Divider, InputLabel, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";

export function BulkLoad({ open, close }) {
  const { t } = useTranslation();
  const [view, setView] = useState(0) // 0=categories, 1=subcategories, 2=products, 3=variants
  const [schemaMenu, setSchemaMenu] = useState([])

  const handleChangeCategoriesTextarea = (event) => {
    setSchemaMenu([])
    if (event.target.value !== null && event.target.value !== undefined && event.target.value !== "") {
      event.target.value.split('\n').forEach((category) => {
        if (category === "") 
          category = "Categoría"
        setSchemaMenu((prev) => [...prev, { name: category, subcategories: [{ name: "Default", products: [] }] }])
      })
    }
  }

  const handleChangeSubcategoriesTextarea = (event, index) => {
    const newSchemaMenu = [...schemaMenu]
    newSchemaMenu[index].subcategories = []
    if (event.target.value !== null && event.target.value !== undefined && event.target.value !== "") {
      event.target.value.split('\n').forEach((subcategory) => {
        if (subcategory === "") 
          subcategory = "Subcategoría"
        newSchemaMenu[index].subcategories.push({ name: subcategory, products: [] })
      })
    }
    setSchemaMenu(newSchemaMenu)
  }

  const handleChangeProductsTextarea = (event, indexCat, indexSub) => {
    const newSchemaMenu = [...schemaMenu]
    newSchemaMenu[indexCat].subcategories[indexSub].products = []
    if (event.target.value !== null && event.target.value !== undefined && event.target.value !== "") {
      event.target.value.split('\n').forEach((product) => {
        if (product === "") 
          product = "Nombre del producto\t0"
        const format = product.replace('\t', ',')
        const sep = format.split(',')
        newSchemaMenu[indexCat].subcategories[indexSub].products.push({ 
          name: sep[0] !== undefined && sep[0] !== null && sep[0] !== "" ? sep[0] : "Nombre del producto", 
          price: sep[1] !== undefined && sep[1] !== null && sep[1] !== "" ? sep[1] : 0
        })
      })
    }
    setSchemaMenu(newSchemaMenu)
  }

  const handleBack = () => { if (view !== 0) setView(view - 1) }
  const handleNext = () => { if (view !== 3) setView(view + 1) }

  return (
    <FlexibleWidthDialog maxWidth="sm" open={open} title={t('builder_bulkload_dialog_title')} /* actions={<Actions />} */>
      <>{/* <code>{JSON.stringify(schemaMenu)}</code> */}
        {view === 0 ? <>
          <Typography sx={{ mb: 2, fontWeight: "bold" }}> {t('builder_bulkload_dialog_description_categories')} </Typography>
          <InputLabel htmlFor="categories_textarea" required style={{ fontSize: 14 }}>{t('builder_bulkload_dialog_label_categories_textarea')}</InputLabel>
          <TextField fullWidth multiline margin="dense" size="medium"
            id="categories_textarea" name="categories_textarea"
            value={schemaMenu.map((category) => category.name).join('\n')}
            onChange={handleChangeCategoriesTextarea}
            onPaste={handleChangeCategoriesTextarea} />
        </> : null}
        {view === 1 ? <>
          <Typography sx={{ mb: 2, fontWeight: "bold" }}> {t('builder_bulkload_dialog_description_subcategories')} </Typography>
          {schemaMenu.map((category, index) => (<div key={index}>
            <InputLabel htmlFor={`subcategories_textarea-${index}`} required style={{ fontWeight: "bold", fontSize: 16 }}>{category.name}</InputLabel>
            <TextField fullWidth multiline margin="dense" size="medium" sx={{ mb: 3 }}
              id={`subcategories_textarea-${index}`}
              name={`subcategories_textarea-${index}`}
              value={category.subcategories.map((subcategory) => subcategory.name).join('\n')}
              onChange={(e) => handleChangeSubcategoriesTextarea(e, index)} />
            <Divider sx={{ my: 2 }} />
          </div>))}
        </> : null}
        {view === 2 ? <>
          <Typography sx={{ mb: 2, fontWeight: "bold" }}> {t('builder_bulkload_dialog_description_products')} </Typography>
          {schemaMenu.map((category, indexCat) => (<div key={indexCat}>
            <Typography sx={{ mb: 2, fontWeight: "bold" }}> {category.name} </Typography>
            {category.subcategories.map((subcategory, indexSub) => (<div key={indexSub}>
              <InputLabel htmlFor={`products_textarea-${indexCat}-${indexSub}`} required style={{ fontWeight: "bold", fontSize: 16 }}>{subcategory.name}</InputLabel>
              <TextField fullWidth multiline margin="dense" size="medium" sx={{ mb: 3 }}
                id={`products_textarea-${indexCat}-${indexSub}`}
                name={`products_textarea-${indexCat}-${indexSub}`}
                value={subcategory.products.map((product) => `${product.name},${product.price}`).join('\n')}
                onChange={(e) => handleChangeProductsTextarea(e, indexCat, indexSub)} />
            </div>))}
            <Divider sx={{ my: 2 }} />
          </div>))}
        </> : null}

        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button color="inherit" disabled={view === 0} onClick={handleBack} sx={{ mr: 1 }} > Back </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button onClick={handleNext}> {view === 2 ? 'Finish' : 'Next'} </Button>
        </Box>
      </>
    </FlexibleWidthDialog>
  )
}